import auth from '@/common/auth/auth';

export default function AuthManager() {
    return {
        /* eslint-disable func-names */
        /* eslint-disable object-shorthand */
        install: function (Vue) {
            Vue.prototype.$auth = auth;
        },
    };
}
